var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Close-large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Client---revoke-access-success-Copy",
    transform: "translate(-591.000000, -340.000000)",
    fill: "#FF0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(382.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.000000, 98.000000)",
    id: "Icon/Close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,24 C45.6,24 24,45.6 24,72 C24,98.4 45.6,120 72,120 C98.4,120 120,98.4 120,72 C120,45.6 98.4,24 72,24 Z M93,84.6 L84.6,93 L72,80.4 L59.4,93 L51,84.6 L63.6,72 L51,59.4 L59.4,51 L72,63.6 L84.6,51 L93,59.4 L80.4,72 L93,84.6 Z",
    id: "Fill"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleRed);
export default __webpack_public_path__ + "static/media/close-circle-red.5b6215567ecd7e58184f8d317016e385.svg";
export { ForwardRef as ReactComponent };